export const people_data = {
   "enrique-bradley": {
      "name": "Enrique Bradley",
      "photos": [
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008772.jpg",
            "slug": "family-bonding-during-quarantine-4008772-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008772-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008772-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008772-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008772-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008772-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008772-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008773.jpg",
            "slug": "family-bonding-during-quarantine-4008773-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008773-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008773-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008773-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "cute-little-boys-4008827.jpg",
            "slug": "cute-little-boys-4008827-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_cute-little-boys-4008827-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_cute-little-boys-4008827-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_cute-little-boys-4008827-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_cute-little-boys-4008827-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_cute-little-boys-4008827-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_cute-little-boys-4008827-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008790.jpg",
            "slug": "family-bonding-during-quarantine-4008790-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008790-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008783.jpg",
            "slug": "family-bonding-during-quarantine-4008783-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008783-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "kids-playing-with-tissue-roll-4008795.jpg",
            "slug": "kids-playing-with-tissue-roll-4008795-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_kids-playing-with-tissue-roll-4008795-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_kids-playing-with-tissue-roll-4008795-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_kids-playing-with-tissue-roll-4008795-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_kids-playing-with-tissue-roll-4008795-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_kids-playing-with-tissue-roll-4008795-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_kids-playing-with-tissue-roll-4008795-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008802.jpg",
            "slug": "family-bonding-during-quarantine-4008802-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008802-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008881.jpg",
            "slug": "family-bonding-during-quarantine-4008881-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008881-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008881-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008881-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008881-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008881-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008881-jpg.jpg",
            "width": 1280
         }
      ],
      "slug": "enrique-bradley",
      "src": "/fussel-demo/static/_gallery/albums/our-family/enrique-bradley_original_family-bonding-during-quarantine-4008772-jpg.jpg"
   },
   "eren-bradley": {
      "name": "Eren Bradley",
      "photos": [
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008772.jpg",
            "slug": "family-bonding-during-quarantine-4008772-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008772-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008772-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008772-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008772-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008772-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008772-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "cute-little-boys-4008827.jpg",
            "slug": "cute-little-boys-4008827-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_cute-little-boys-4008827-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_cute-little-boys-4008827-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_cute-little-boys-4008827-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_cute-little-boys-4008827-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_cute-little-boys-4008827-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_cute-little-boys-4008827-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008790.jpg",
            "slug": "family-bonding-during-quarantine-4008790-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008790-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008783.jpg",
            "slug": "family-bonding-during-quarantine-4008783-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008783-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008776.jpg",
            "slug": "family-bonding-during-quarantine-4008776-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008776-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008776-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008776-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008802.jpg",
            "slug": "family-bonding-during-quarantine-4008802-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008802-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "mommy-kissing-little-boy-4008819.jpg",
            "slug": "mommy-kissing-little-boy-4008819-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_mommy-kissing-little-boy-4008819-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_mommy-kissing-little-boy-4008819-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_mommy-kissing-little-boy-4008819-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_mommy-kissing-little-boy-4008819-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_mommy-kissing-little-boy-4008819-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_mommy-kissing-little-boy-4008819-jpg.jpg",
            "width": 1280
         }
      ],
      "slug": "eren-bradley",
      "src": "/fussel-demo/static/_gallery/albums/our-family/eren-bradley_original_family-bonding-during-quarantine-4008772-jpg.jpg"
   },
   "monty-bradley": {
      "name": "Monty Bradley",
      "photos": [
         {
            "faces": [],
            "height": 853,
            "name": "checking-their-planner-4008732.jpg",
            "slug": "checking-their-planner-4008732-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_checking-their-planner-4008732-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_checking-their-planner-4008732-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_checking-their-planner-4008732-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_checking-their-planner-4008732-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_checking-their-planner-4008732-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_checking-their-planner-4008732-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "couple-hugging-4008834.jpg",
            "slug": "couple-hugging-4008834-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_couple-hugging-4008834-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_couple-hugging-4008834-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_couple-hugging-4008834-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_couple-hugging-4008834-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_couple-hugging-4008834-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_couple-hugging-4008834-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008773.jpg",
            "slug": "family-bonding-during-quarantine-4008773-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008773-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008773-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008773-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "couple-checking-their-planner-4008738.jpg",
            "slug": "couple-checking-their-planner-4008738-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_couple-checking-their-planner-4008738-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_couple-checking-their-planner-4008738-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_couple-checking-their-planner-4008738-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_couple-checking-their-planner-4008738-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_couple-checking-their-planner-4008738-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_couple-checking-their-planner-4008738-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008790.jpg",
            "slug": "family-bonding-during-quarantine-4008790-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008790-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008783.jpg",
            "slug": "family-bonding-during-quarantine-4008783-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008783-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008776.jpg",
            "slug": "family-bonding-during-quarantine-4008776-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008776-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008776-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008776-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008802.jpg",
            "slug": "family-bonding-during-quarantine-4008802-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008802-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "woman-sitting-on-man-s-lap-4008708.jpg",
            "slug": "woman-sitting-on-man-s-lap-4008708-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_woman-sitting-on-man-s-lap-4008708-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_woman-sitting-on-man-s-lap-4008708-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1706,
            "name": "people-gathered-inside-house-sitting-on-sofa-1054974.jpg",
            "slug": "people-gathered-inside-house-sitting-on-sofa-1054974-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1706_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1364_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1706_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x666_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1066_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x666_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "woman-cooking-while-holding-her-laptop-4008741.jpg",
            "slug": "woman-cooking-while-holding-her-laptop-4008741-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1919,
            "name": "woman-sitting-on-the-desk-holding-a-book-4008713.jpg",
            "slug": "woman-sitting-on-the-desk-holding-a-book-4008713-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1919_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1535_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1919_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x749_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1199_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x749_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg",
            "width": 1280
         }
      ],
      "slug": "monty-bradley",
      "src": "/fussel-demo/static/_gallery/albums/our-family/monty-bradley_original_checking-their-planner-4008732-jpg.jpg"
   },
   "raife-lancaster": {
      "name": "Raife Lancaster",
      "photos": [
         {
            "faces": [],
            "height": 853,
            "name": "checking-their-planner-4008732.jpg",
            "slug": "checking-their-planner-4008732-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_checking-their-planner-4008732-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_checking-their-planner-4008732-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_checking-their-planner-4008732-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_checking-their-planner-4008732-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_checking-their-planner-4008732-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_checking-their-planner-4008732-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "couple-hugging-4008834.jpg",
            "slug": "couple-hugging-4008834-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_couple-hugging-4008834-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_couple-hugging-4008834-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_couple-hugging-4008834-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_couple-hugging-4008834-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_couple-hugging-4008834-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_couple-hugging-4008834-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008773.jpg",
            "slug": "family-bonding-during-quarantine-4008773-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008773-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008773-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008773-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "couple-checking-their-planner-4008738.jpg",
            "slug": "couple-checking-their-planner-4008738-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_couple-checking-their-planner-4008738-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_couple-checking-their-planner-4008738-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_couple-checking-their-planner-4008738-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_couple-checking-their-planner-4008738-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_couple-checking-their-planner-4008738-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_couple-checking-their-planner-4008738-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008790.jpg",
            "slug": "family-bonding-during-quarantine-4008790-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008790-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008783.jpg",
            "slug": "family-bonding-during-quarantine-4008783-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008783-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008776.jpg",
            "slug": "family-bonding-during-quarantine-4008776-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008776-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008776-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008776-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008802.jpg",
            "slug": "family-bonding-during-quarantine-4008802-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008802-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008881.jpg",
            "slug": "family-bonding-during-quarantine-4008881-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008881-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008881-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008881-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008881-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008881-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008881-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "woman-sitting-on-man-s-lap-4008708.jpg",
            "slug": "woman-sitting-on-man-s-lap-4008708-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_woman-sitting-on-man-s-lap-4008708-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_woman-sitting-on-man-s-lap-4008708-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "woman-cooking-while-holding-her-laptop-4008741.jpg",
            "slug": "woman-cooking-while-holding-her-laptop-4008741-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1919,
            "name": "woman-sitting-on-the-desk-holding-a-book-4008713.jpg",
            "slug": "woman-sitting-on-the-desk-holding-a-book-4008713-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1919_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1535_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1919_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x749_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1199_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x749_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg",
            "width": 1280
         }
      ],
      "slug": "raife-lancaster",
      "src": "/fussel-demo/static/_gallery/albums/our-family/raife-lancaster_original_checking-their-planner-4008732-jpg.jpg"
   },
   "saima-lake": {
      "name": "Saima Lake",
      "photos": [
         {
            "faces": [],
            "height": 5559,
            "name": "happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211.jpg",
            "slug": "happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1600x2400_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1600x2400_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg",
            "width": 3706
         }
      ],
      "slug": "saima-lake",
      "src": "/fussel-demo/static/_gallery/albums/our-family/saima-lake_original_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg"
   }
};